// jQueryプラグイン
// import 'jquery.easing';
/* -----------------------------------------------------
ページ内リンクのアニメーション
------------------------------------------------------- */
export function pageLinkAnimationFunc() {
  $('a[href^="#"]').click(function() {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
}

export function pageMoveAnkerFunc() {
  // var headerHeight,position;
  // $('a[href^="#"]:not(.notScroll)').each(function () {
  //   var pageUrl = location.href.split('#')[0];
  //   if (this.href.indexOf(pageUrl + '#') === 0) {
  //     var id = this.href.split('#')[1];
  //     $(this).on('click', function () {
  //       headerHeight = $('#header').outerHeight(true);
  //       position = $('#' + id).offset().top - headerHeight;
  //       $('body,html').animate({
  //         scrollTop: position
  //       }, 1000, 'easeInOutQuart');
  //       return false;
  //     });
  //   }
  // });

    var headerHight = $('#header').outerHeight(true) + 10;
    jQuery('.toc_list a[href^="#"]').click(function() {
    var speed = 500;
    var href= jQuery(this).attr("href");
    var target = jQuery(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top-headerHight;
    jQuery('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
   });
}